/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ManageQuestionerDTO } from '../models/ManageQuestionerDTO';
import type { QualifyResultDto } from '../models/QualifyResultDto';
import type { QuestionerAnswersDTOInput } from '../models/QuestionerAnswersDTOInput';
import type { QuestionerAnswersDTOOutput } from '../models/QuestionerAnswersDTOOutput';
import type { QuestionerAnswersDTOOutputSimple } from '../models/QuestionerAnswersDTOOutputSimple';
import type { QuestionerDTO } from '../models/QuestionerDTO';
import type { QuestionerIdDTOOutput } from '../models/QuestionerIdDTOOutput';
import type { SendSsToRelativeFromPatientDto } from '../models/SendSsToRelativeFromPatientDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class QuestionerService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns QuestionerDTO
     * @throws ApiError
     */
    public getSymptomSurveyQuestioner(): CancelablePromise<QuestionerDTO> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/questioner/symptom-survey',
        });
    }

    /**
     * Create a new questioner
     * @param requestBody
     * @returns QuestionerDTO
     * @throws ApiError
     */
    public create(
        requestBody: ManageQuestionerDTO,
    ): CancelablePromise<QuestionerDTO> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/questioner',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Get questioners for user
     * @param xClientRequester Who is requesting questioners
     * @returns QuestionerDTO
     * @throws ApiError
     */
    public getQuestioners(
        xClientRequester: string,
    ): CancelablePromise<Array<QuestionerDTO>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/questioner',
            headers: {
                'x-client-requester': xClientRequester,
            },
        });
    }

    /**
     * Update an existent questioner
     * @param id
     * @param requestBody
     * @returns QuestionerDTO
     * @throws ApiError
     */
    public update(
        id: string,
        requestBody: ManageQuestionerDTO,
    ): CancelablePromise<QuestionerDTO> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/questioner/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Delete an existent questioner
     * @param id
     * @returns any
     * @throws ApiError
     */
    public delete(
        id: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/questioner/{id}',
            path: {
                'id': id,
            },
        });
    }

    /**
     * Get a questioner by id
     * @param id
     * @returns QuestionerDTO
     * @throws ApiError
     */
    public getById(
        id: string,
    ): CancelablePromise<QuestionerDTO> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/questioner/{id}',
            path: {
                'id': id,
            },
        });
    }

    /**
     * Get all questioners
     * @returns QuestionerDTO
     * @throws ApiError
     */
    public getAllQuestioners(): CancelablePromise<Array<QuestionerDTO>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/questioner/all',
        });
    }

    /**
     * @returns QuestionerDTO
     * @throws ApiError
     */
    public getFaq(): CancelablePromise<QuestionerDTO> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/questioner/faq',
        });
    }

    /**
     * Get vitalis demo result
     * @param id
     * @returns QuestionerAnswersDTOOutput
     * @throws ApiError
     */
    public getVitalisResult(
        id: string,
    ): CancelablePromise<QuestionerAnswersDTOOutput> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/questioner-answer/vitalis/{id}',
            path: {
                'id': id,
            },
        });
    }

    /**
     * Save new user answer on questioner. Returns id of created answer
     * @param requestBody
     * @returns QuestionerIdDTOOutput
     * @throws ApiError
     */
    public create1(
        requestBody: QuestionerAnswersDTOInput,
    ): CancelablePromise<QuestionerIdDTOOutput> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/questioner-answer',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Save new user answer on questioner. Returns id of created answer. Can be performed only by one time user
     * @param requestBody
     * @returns QuestionerIdDTOOutput
     * @throws ApiError
     */
    public createAsOneTimeUser(
        requestBody: QuestionerAnswersDTOInput,
    ): CancelablePromise<QuestionerIdDTOOutput> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/questioner-answer/one-time-respondent',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Update existent answer as a one time user
     * @param id
     * @param requestBody
     * @returns QuestionerAnswersDTOOutputSimple
     * @throws ApiError
     */
    public updateAsOneTimeUser(
        id: string,
        requestBody: QuestionerAnswersDTOInput,
    ): CancelablePromise<QuestionerAnswersDTOOutputSimple> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/questioner-answer/{id}/one-time-respondent',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Update existent answer as a patient
     * @param id
     * @param requestBody
     * @returns QuestionerAnswersDTOOutputSimple
     * @throws ApiError
     */
    public update1(
        id: string,
        requestBody: QuestionerAnswersDTOInput,
    ): CancelablePromise<QuestionerAnswersDTOOutputSimple> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/questioner-answer/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Check if user was qualified to pass tests
     * @returns QualifyResultDto
     * @throws ApiError
     */
    public checkIsQualified(): CancelablePromise<QualifyResultDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/questioner-answer/check-qualified',
        });
    }

    /**
     * Get last unfinished questioner-answer for patient
     * @param kind
     * @returns QuestionerAnswersDTOOutputSimple
     * @throws ApiError
     */
    public getUnfinishedQuestionerAnswer(
        kind: string,
    ): CancelablePromise<QuestionerAnswersDTOOutputSimple> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/questioner-answer/unfinished/{kind}',
            path: {
                'kind': kind,
            },
        });
    }

    /**
     * Sends and sms/email to the doctor that patient has finished answering questions.
     * @returns any
     * @throws ApiError
     */
    public notifyFinishedAnswering(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/med-staff/notify-finished-answering',
        });
    }

    /**
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    public sendSsToRelativeFromPatient(
        requestBody: SendSsToRelativeFromPatientDto,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/sms/send-ss/to-relative-from-patient',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    public sendFaqToRelativeFromPatient(
        requestBody: SendSsToRelativeFromPatientDto,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/sms/send-faq/to-relative-from-patient',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
